import { render, staticRenderFns } from "./PromisePage.vue?vue&type=template&id=4363458b&scoped=true"
import script from "./PromisePage.vue?vue&type=script&lang=js"
export * from "./PromisePage.vue?vue&type=script&lang=js"
import style0 from "./PromisePage.vue?vue&type=style&index=0&id=4363458b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4363458b",
  null
  
)

export default component.exports